import { render, staticRenderFns } from "./ReportPolice.vue?vue&type=template&id=753c3e78&scoped=true"
import script from "./ReportPolice.vue?vue&type=script&lang=ts"
export * from "./ReportPolice.vue?vue&type=script&lang=ts"
import style0 from "./ReportPolice.vue?vue&type=style&index=0&id=753c3e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c3e78",
  null
  
)

export default component.exports